import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MONTH_GRID_COLUMNS } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { FlatRowDateMonthList } from "web_myplann/Shared/Components/FlatRow/FlatRowDateMonthList";
import { FlatRowDatePanelGrid } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelGrid";
import { FlatRowDatePanelHeader } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelHeader";
import { getYearMonths } from "web_myplann/Shared/Components/FlatRow/getYearMonths";
import { isYearStepEnabled } from "web_myplann/Shared/Components/FlatRow/isYearStepEnabled";

type Props = {
	year: number;
	selectedMonth: Date | null;
	minDate?: Date;
	maxDate?: Date;
	onYearChange: (year: number) => void;
	onTitleClick: () => void;
	onSelect: (month: Date) => void;
};

export const FlatRowDateMonthView: FC<Props> = ({
	year,
	selectedMonth,
	minDate,
	maxDate,
	onYearChange,
	onTitleClick,
	onSelect,
}) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowDatePanelHeader
				title={String(year)}
				titleLabel={t(Resources.Common.DatePicker.chooseYear, { year })}
				onTitleClick={onTitleClick}
				previousLabel={t(Resources.Common.DatePicker.previousYear)}
				nextLabel={t(Resources.Common.DatePicker.nextYear)}
				previousEnabled={isYearStepEnabled(year, -1, minDate, maxDate)}
				nextEnabled={isYearStepEnabled(year, 1, minDate, maxDate)}
				onPrevious={() => onYearChange(year - 1)}
				onNext={() => onYearChange(year + 1)}
			/>
			<FlatRowDatePanelGrid columns={MONTH_GRID_COLUMNS}>
				<FlatRowDateMonthList
					months={getYearMonths(year)}
					value={selectedMonth}
					minDate={minDate}
					maxDate={maxDate}
					onSelect={onSelect}
				/>
			</FlatRowDatePanelGrid>
		</>
	);
};
